import { datadogRum } from '@datadog/browser-rum';

type ClientLogger = {
  allowedTracingUrls: string[];
  enableSessionRecordings: boolean;
  clientToken?: string;
  env?: string;
  version?: string;
};

export const initializeClientLogger = (clientLogger: ClientLogger): void => {
  const { allowedTracingUrls, enableSessionRecordings, clientToken, env, version } = clientLogger;
  if (clientToken && env) {
    // Cloud Run is making an internal request so it is logging the url as http, this is an attempt for RUM correlation
    const transformedTracingUrls = allowedTracingUrls.map((url) => url.replace('https', 'http'));

    datadogRum.init({
      allowedTracingUrls: [...allowedTracingUrls, ...transformedTracingUrls],
      applicationId: '72f03cda-00b2-4f17-9c83-10413c96a03b',
      clientToken,
      defaultPrivacyLevel: 'mask',
      env,
      service: 'brandguide-v2',
      silentMultipleInit: true,
      site: 'datadoghq.com',
      trackLongTasks: true,
      trackResources: true,
      trackUserInteractions: true,
      version
    });

    if (enableSessionRecordings) {
      datadogRum.startSessionReplayRecording();
    }
  }
};
